import API from 'services/api';

import { ISmsTemplate } from '../models/ISmsTemplate';

interface IProps {
  id: string;
  calculationId: string;
  payload: ISmsTemplate;
}

export const sendTemplateSms = ({ id, calculationId, payload }: IProps): Promise<null> =>
  API.post(
    `api/accommodation/templates/${id}/calculations/${calculationId}/send_sms`,
    payload,
  ).then(response => response?.data);
